import moment from 'moment'

import { getNestedProperty } from '../../../utilities/parsers'

const defaultColumnProps = {
  sortable: false,
  resizable: true,
  isVisible: true,
}

export const getColumns = ({ onViewAction }: any) => {
  const createRenderCell = (key: string, isCustom?: string) => (row: any) => {
    if (isCustom === 'date') {
      const dateValue = getNestedProperty(row, key)
      return {
        cell: <>{dateValue ? moment(dateValue).format('DD-MM-YYYY') : ''}</>,
      }
    } else {
      return {
        cell: getNestedProperty(row, key),
        toolTip: getNestedProperty(row, key) ?? '',
      }
    }
  }

  const column = [
    {
      title: 'Organisation Name',
      field: 'name',
      ...defaultColumnProps,
      fixed: true,
      customCell: true,
      // link: true,
      rowClick: (row: any) => onViewAction(row),
    },
    {
      title: 'Gender Age Breakdown',
      field: 'last_updated_engagement',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_engagement', 'date'),
    },
    {
      title: 'External Recruitment by Grade',
      field: 'last_updated_external',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_external', 'date'),
    },
    {
      title: 'Attrition (Resignation) by Grade',
      field: 'last_updated_attrition',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_attrition', 'date'),
    },
    {
      title: 'Sickness Absence by Grade',
      field: 'last_updated_sickness',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_sickness', 'date'),
    },
    {
      title: 'Flexible Working Requests (Submitted & Approved)',
      field: 'last_updated_flexible',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_flexible', 'date'),
      colWidth: 350,
    },
    // {
    //   name: 'Organisation Datatable Update Report',
    //   type: 'organisation-datatable-update-report',
    //   rowTitle: undefined,
    //   descKey: 'org_datatable_update_report',
    //   seperationLine: true,
    // },
    {
      title: 'Gender Breakdown (Legacy)',
      field: 'last_updated_gender',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_gender', 'date'),
    },
    {
      title: 'Age Breakdown (Legacy)',
      field: 'last_updated_age',
      ...defaultColumnProps,
      customCell: true,
      renderCell: createRenderCell('last_updated_age', 'date'),
    },
  ]

  return column
}
